var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltersArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 13,
    viewBox: "0 0 51 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2335 6.4414C50.4777 6.31242 50.5711 6.00992 50.4421 5.76575C50.3131 5.52158 50.0106 5.42821 49.7664 5.5572L50.2335 6.4414ZM0.846301 1.5235C0.583524 1.60836 0.439294 1.89018 0.52416 2.15296L1.90711 6.43519C1.99197 6.69796 2.27379 6.84219 2.53657 6.75733C2.79935 6.67246 2.94358 6.39064 2.85871 6.12786L1.62943 2.32144L5.43585 1.09216C5.69863 1.00729 5.84285 0.72547 5.75799 0.462692C5.67313 0.199913 5.3913 0.0556848 5.12853 0.14055L0.846301 1.5235ZM49.7664 5.5572C41.0444 10.1648 34.001 11.742 26.6254 10.9024C19.2223 10.0596 11.4354 6.77821 1.22775 1.5542L0.772174 2.4444C10.9855 7.6713 18.9133 11.0309 26.5123 11.896C34.1387 12.7641 41.3848 11.1159 50.2335 6.4414L49.7664 5.5572Z",
    fill: "#5E6C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersArrow);
export default __webpack_public_path__ + "static/media/filters_arrow.7898401ee746f92dd14b9f2d29bc5b32.svg";
export { ForwardRef as ReactComponent };